"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailFields = exports.asyncValidateEmail = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reduxForm = require("redux-form");

var _validateEmail = require("./validateEmail");

var _types = require("../../types");

var _componentDefinitionTypes = require("../../components/config/componentDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldsetDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.FieldsetDefinition;
});

var PersonalDetailsDefinition = _flowRuntime["default"].tdz(function () {
  return _componentDefinitionTypes.PersonalDetailsDefinition;
});

var FormDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FormDefinition;
});

var FormProps = _flowRuntime["default"].tdz(function () {
  return _reduxForm.FormProps;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].intersection(_flowRuntime["default"].object(_flowRuntime["default"].property("formStructure", _flowRuntime["default"].ref(FormDefinition))), _flowRuntime["default"].ref(FormProps)));

var createObjectFromDotNotation = function createObjectFromDotNotation(key, value) {
  var obj = {};
  var parts = key.split('.');

  if (parts.length === 1) {
    obj[parts[0]] = value;
  } else if (parts.length > 1) {
    var remainingParts = parts.slice(1, parts.length).join('.');
    obj[parts[0]] = createObjectFromDotNotation(remainingParts, value);
  }

  return obj;
};

var emailFields = function emailFields(form) {
  var componentsWithEmailFields = function componentsWithEmailFields() {
    var components = [];

    if (form) {
      form.pages.forEach(function (page) {
        if (page.components) {
          page.components.forEach(function (component) {
            if (component.type === 'fieldset' || component.type === 'personalDetails') {
              components.push(component);
            }
          });
        }
      });
    }

    return components;
  };

  var emailFieldsArray = [];
  componentsWithEmailFields().forEach(function (component) {
    if (component.type === 'fieldset') {
      component.fields.forEach(function (field) {
        if (field.type === 'email') {
          emailFieldsArray.push("".concat(component.key, ".").concat(field.key));
        }
      });
    }

    if (component.type === 'personalDetails') {
      if (component.options.email) {
        emailFieldsArray.push("".concat(component.key, ".email"));
      }

      if (component.options.alternativeEmail) {
        emailFieldsArray.push("".concat(component.key, ".alternativeEmail"));
      }
    }
  });
  return emailFieldsArray;
};

exports.emailFields = emailFields;

var asyncValidateEmail = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(values, dispatch, props, blurredField) {
    var formStructure, fields, errors, i, field, fieldValue, isValidEmail;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formStructure = props.formStructure;
            fields = emailFields(formStructure);

            if (!(blurredField && fields && fields.length > 0)) {
              _context.next = 18;
              break;
            }

            errors = {};
            i = 0;

          case 5:
            if (!(i < fields.length)) {
              _context.next = 16;
              break;
            }

            field = fields[i];
            fieldValue = _lodash["default"].get(values, field);

            if (!fieldValue) {
              _context.next = 13;
              break;
            }

            _context.next = 11;
            return (0, _validateEmail.validateEmail)(fieldValue);

          case 11:
            isValidEmail = _context.sent;

            if (!isValidEmail) {
              // This does a deep merge as opposed to Object.assign, so preserves both email and alternative email errors if present
              _lodash["default"].merge(errors, createObjectFromDotNotation(field, 'Please enter a valid email address'));
            }

          case 13:
            i += 1;
            _context.next = 5;
            break;

          case 16:
            if (_lodash["default"].isEmpty(errors)) {
              _context.next = 18;
              break;
            }

            throw errors;

          case 18:
            return _context.abrupt("return", null);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function asyncValidateEmail(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.asyncValidateEmail = asyncValidateEmail;